<div>
    Aktualisierung zulassen, damit Inhalte und Dienste im Hintergrund neu geladen werden können.

    <button mat-button (click)="accept($event)">Jetzt aktualisieren</button>
    <button mat-button (click)="decline($event)">Später</button>
</div>
